import { render, staticRenderFns } from "./DeveloperListHouses.vue?vue&type=template&id=436dde1f&"
import script from "./DeveloperListHouses.vue?vue&type=script&lang=js&"
export * from "./DeveloperListHouses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports